import { JSX, useState } from "react";
import { CategorySubItem } from "./CategorySubItem";
import {
    ProductGridItem,
    ProductListHeader,
    ProductListItem,
} from "@hatch-digital-nl/bravilor-storybook";
import { SimpleProduct } from "../../interfaces/SimpleProduct";
import { RouteEnum } from "../../enums/RouteEnum";
import { useNavigate } from "react-router-dom";
import { getLocalizedText } from "../../utils/getLocalizedText";
import { convertProduct } from "../../utils/productConverter";
import { asStorybookProduct } from "../../utils/storybookProduct";
import { ProductInterface } from "../../interfaces/ProductInterface";
import { CategoryListInterface } from "../../interfaces/CategoryListInterface";

interface Props {
    category: CategoryListInterface;
    products?: ProductInterface[];
    gridLayout: boolean;
    standardActive?: boolean;
    productImages: { [key: string]: string };
}

export const CategoryItem = (props: Props): JSX.Element | null => {
    const { category, products, gridLayout, standardActive, productImages } =
        props;
    const { children } = category;
    const navigate = useNavigate();
    const [active, setActive] = useState(false);

    const handleProductClick = (product: SimpleProduct): void => {
        navigate(RouteEnum.PRODUCT_RANGE + `/${product.id}`);
    };

    if (
        (children &&
            children.length > 0 &&
            children.some(
                (child) => child.products && child.products.length > 0,
            )) ||
        (products && products.length > 0)
    ) {
        return (
            <div
                className={
                    "c-products-list__item " +
                    (active || standardActive ? "is-active" : "")
                }
            >
                <ProductListHeader
                    isActive={active || standardActive}
                    onToggle={() => setActive(!active)}
                    label={getLocalizedText(category.label)}
                    showIcon={!standardActive}
                    variant={"main"}
                />

                {children &&
                children.length > 0 &&
                children.some(
                    (child) => child.products && child.products.length > 0,
                ) ? (
                    <div
                        className={
                            "c-products-list__sub-items " +
                            (standardActive
                                ? "c-products-list__sub-items--standard-active"
                                : "")
                        }
                    >
                        {children.map((child: CategoryListInterface) => (
                            <CategorySubItem
                                key={"category-" + child.id}
                                child={child}
                                disableCheckbox={true}
                                productImages={productImages}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="c-products-list__sub-items">
                        <div className="c-products-list__sub-item is-active">
                            {!!products && products.length > 0 && (
                                <div
                                    className={
                                        "c-products-list__sub-item__items " +
                                        (gridLayout
                                            ? "c-products-list__sub-item__items--grid"
                                            : "")
                                    }
                                >
                                    {products.map((product) => {
                                        if (gridLayout) {
                                            const gridProduct: SimpleProduct =
                                                convertProduct(
                                                    product,
                                                    productImages,
                                                    "grid",
                                                );

                                            return (
                                                <ProductGridItem
                                                    key={
                                                        "grid-" + gridProduct.id
                                                    }
                                                    product={asStorybookProduct(
                                                        gridProduct,
                                                    )}
                                                    viewProductText={
                                                        "View Product"
                                                    }
                                                    showSelectCheckbox={false}
                                                    onProductClick={(
                                                        selectedProduct,
                                                    ) =>
                                                        handleProductClick(
                                                            selectedProduct as SimpleProduct,
                                                        )
                                                    }
                                                    onProductSelect={(
                                                        selectedProduct,
                                                    ) =>
                                                        handleProductClick(
                                                            selectedProduct as SimpleProduct,
                                                        )
                                                    }
                                                    lazyLoad={true}
                                                />
                                            );
                                        }

                                        const listProduct: SimpleProduct =
                                            convertProduct(
                                                product,
                                                productImages,
                                                "list",
                                            );
                                        return (
                                            <ProductListItem
                                                key={"list-" + product.id}
                                                product={asStorybookProduct(
                                                    listProduct,
                                                )}
                                                showSelectCheckbox={false}
                                                redirectUrl={
                                                    RouteEnum.PRODUCT_RANGE +
                                                    `/${product.id}`
                                                }
                                                onProductSelect={(
                                                    selectedProduct,
                                                ) =>
                                                    handleProductClick(
                                                        selectedProduct as SimpleProduct,
                                                    )
                                                }
                                            />
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    return null;
};
